import { render, staticRenderFns } from "./MyApplicationsTable.vue?vue&type=template&id=4c9464c0"
import script from "./MyApplicationsTable.vue?vue&type=script&lang=ts"
export * from "./MyApplicationsTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports